/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { VSTToken, VSTTokenInterface } from "../VSTToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_stabilityPoolManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newBorrowerOperationsAddress",
        type: "address",
      },
    ],
    name: "BorrowerOperationsAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "state",
        type: "bool",
      },
    ],
    name: "EmergencyStopMintingCollateral",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newStabilityPoolAddress",
        type: "address",
      },
    ],
    name: "StabilityPoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
    ],
    name: "TroveManagerAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "VSTTokenBalanceUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "borrowerOperationsAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "chainId",
    outputs: [
      {
        internalType: "uint256",
        name: "chainID",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "emergencyStopMinting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "emergencyStopMintingCollateral",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_poolAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "returnFromPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "_poolAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "sendToPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stabilityPoolManager",
    outputs: [
      {
        internalType: "contract IStabilityPoolManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "troveManagerAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type VSTTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VSTTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VSTToken__factory extends ContractFactory {
  constructor(...args: VSTTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _troveManagerAddress: string,
    _stabilityPoolManagerAddress: string,
    _borrowerOperationsAddress: string,
    overrides?: Overrides & { from?: string }
  ): Promise<VSTToken> {
    return super.deploy(
      _troveManagerAddress,
      _stabilityPoolManagerAddress,
      _borrowerOperationsAddress,
      overrides || {}
    ) as Promise<VSTToken>;
  }
  override getDeployTransaction(
    _troveManagerAddress: string,
    _stabilityPoolManagerAddress: string,
    _borrowerOperationsAddress: string,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _troveManagerAddress,
      _stabilityPoolManagerAddress,
      _borrowerOperationsAddress,
      overrides || {}
    );
  }
  override attach(address: string): VSTToken {
    return super.attach(address) as VSTToken;
  }
  override connect(signer: Signer): VSTToken__factory {
    return super.connect(signer) as VSTToken__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VSTTokenInterface {
    return new utils.Interface(_abi) as VSTTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VSTToken {
    return new Contract(address, _abi, signerOrProvider) as VSTToken;
  }
}
